import { render, staticRenderFns } from "./DispatchToAbattoir.vue?vue&type=template&id=7feb2646&scoped=true"
import script from "./DispatchToAbattoir.vue?vue&type=script&lang=ts"
export * from "./DispatchToAbattoir.vue?vue&type=script&lang=ts"
import style0 from "./DispatchToAbattoir.vue?vue&type=style&index=0&id=7feb2646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7feb2646",
  null
  
)

export default component.exports